import "./CommentViewer.less";

export function CommentViewer({
    label,
    comment,
}: {
    label: string;
    comment: string;
}) {
    return (
        <div className="CommentViewer" data-testid="comments-box">
            <div className="label" data-testid="label-comment-section">
                {label}
            </div>
            <div>{comment}</div>
        </div>
    );
}
